module.exports = __webpack_public_path__ + "img/Ic_input_dropdown.5734422f.svg";